import React from "react";
import {
  Flex,
  Text,
  Separator,
  IconButton,
  ScrollArea,
} from "@radix-ui/themes";
import { TenantUserTicket } from "../../entities/TenantUserTicket";
import { TicketButton } from "./TicketButton";
import { ChevronLeftIcon } from "@radix-ui/react-icons";
import { getTicketsToDisplay } from "./ticketUtils";

interface TicketListProps {
  tickets?: TenantUserTicket[];
  onSelectTicket?: (ticket: TenantUserTicket) => void;
  onBack?: () => void;
  statusesToDisplayOnThePage?: string[];
  endUserTicketName?: string;
}

export function TicketList({
  tickets,
  onSelectTicket,
  onBack,
  statusesToDisplayOnThePage,
  endUserTicketName,
}: TicketListProps) {
  const ticketLabel = endUserTicketName ?? "Support Cases";
  const resolvedTickets = tickets ?? [];
  const handleSelectTicket = onSelectTicket ?? (() => undefined);
  const handleBack = onBack ?? (() => undefined);
  const openTickets = getTicketsToDisplay(resolvedTickets, statusesToDisplayOnThePage);

  return (
    <Flex flexGrow={"1"} p={"4"} direction="column" gap="4" overflow={"hidden"}>
      <Flex direction="column" gap="2">
        <IconButton
          variant="outline"
          color="gray"
          onClick={handleBack}
          aria-label="Back to chat"
        >
          <ChevronLeftIcon />
        </IconButton>

        <Text size={"3"} color={"gray"} weight={"medium"} highContrast>
          {`All Open ${ticketLabel}`}
        </Text>
      </Flex>

      <Flex flexGrow={"1"} direction={"column"} overflow={"hidden"}>
        <ScrollArea scrollbars={"vertical"} style={{ width: "100%" }}>
          <Flex direction="column" gap="3">
            {openTickets.map((ticket, index) => (
              <>
                <TicketButton
                  key={ticket.id}
                  ticket={ticket}
                  onClick={handleSelectTicket}
                />

                {index !== openTickets.length - 1 && (
                  <Separator orientation="horizontal" size="4" />
                )}
              </>
            ))}
          </Flex>
        </ScrollArea>
      </Flex>
    </Flex>
  );
}
